import { dispose } from '@react-three/fiber'
import { useEffect, useMemo } from 'react'
import { memoizedRoofMeshes } from '~/components/DrawingCanvas/lib/collisionMeshes'
import { useAppSelector } from '~/store/hooks'

export const useRoofMeshes = () => {
  const roofs = useAppSelector(state => state.objects.present.roofs)
  const lines = useAppSelector(state => state.objects.present.elevationLines)
  const points = useAppSelector(state => state.objects.present.elevationPoints)
  const meshes = memoizedRoofMeshes(roofs, lines, points)
  const cloned = useMemo(() => Array.from(meshes).map(([id, mesh]) => [id, mesh.clone()] as const), [meshes])

  useEffect(() => () => cloned.forEach(([, mesh]) => dispose(mesh)), [cloned])

  return cloned
}
